import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { AdminAuthProvider } from './context/AdminAuthContext.js';
import App from './App.js';
import Index from './assets/js/components/Index.js';
import Header from './assets/js/components/Header.js';
import Footer from './assets/js/components/Footer.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AdminAuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AdminAuthProvider>
  </React.StrictMode>
);
